export default {
  spinner: {
    marginTop: '100px'
  }
}
